import { render, staticRenderFns } from "./eventStudent.vue?vue&type=template&id=b8e7b5f0&scoped=true&"
import script from "./eventStudent.vue?vue&type=script&lang=js&"
export * from "./eventStudent.vue?vue&type=script&lang=js&"
import style0 from "./eventStudent.vue?vue&type=style&index=0&id=b8e7b5f0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b8e7b5f0",
  null
  
)

export default component.exports